import { HttpError } from '../../globals';
import * as AppUtils from '../../utils';
import * as ApiUtils from '../utils';

// tslint:disable:no-any
export async function ErrorLogExtraDataFormatter(obj: any, ...args: any[]): Promise<string[] | null> {
  if (
    ApiUtils.isApiErrorLogExtraData(obj) ||
    ApiUtils.isVerifyActivationTokenApiErrorLogExtraData(obj) ||
    ApiUtils.isSubmitEnrollmentApiErrorLogExtraData(obj) ||
    ApiUtils.isConfirmEnrollmentApiErrorLogExtraData(obj) ||
    ApiUtils.isIntxGotoWebApiErrorLogExtraData(obj)
  ) {
    return Object.keys(obj).map((key) => `<p><strong>${key}:</strong> ${obj[key]}</p>`);
  }
  return null;
}

export async function ErrorObjectFormatter(obj: any, ...args: any[]): Promise<string[] | null> {
  if (obj instanceof Error) {
    const htmlContent = [`<p><strong>Error Message:</strong> ${obj.message}</p>`];
    if (obj instanceof HttpError && obj.response instanceof Response) {
      htmlContent.push(`<p>HTTP Status Code: ${obj.response.status}<br />`);
      htmlContent.push(`HTTP Status Text: ${obj.response.statusText}</p>`);
    }
    if (args.length > 0) {
      const extraHtmlContent = await ErrorLogExtraDataFormatter(args[0]);
      if (extraHtmlContent !== null) {
        extraHtmlContent.forEach((extraContent) => htmlContent.push(extraContent));
      }
    }
    return htmlContent;
  }
  return null;
}

export async function JsonStringifyFormatter(obj: any, ...args: any[]): Promise<string[] | null> {
  try {
    const htmlContent = [`<pre>${JSON.stringify(obj, undefined, 4)}</pre>`];
    if (args.length > 0) {
      const extraHtmlContent = await ErrorLogExtraDataFormatter(args[0]);
      if (extraHtmlContent !== null) {
        extraHtmlContent.forEach((extraContent) => htmlContent.push(extraContent));
      }
    }
    return htmlContent;
  } catch (e) {
    /* ignore */
  }
  return null;
}

export async function ApiErrorResponseFormatter(obj: any, ...args: any[]): Promise<string[] | null> {
  const response = AppUtils.objectHasOwnKeys(obj, ['response']) ? obj.response : obj;
  const responseJson = (await AppUtils.tryGetResponseJson(response)) || response;
  if (ApiUtils.isErrorResponse(responseJson)) {
    const errors = responseJson.Errors;
    const htmlContent = [
      `<p><strong>Error Code:</strong> ${errors[0].Code}</p>`,
      `<p><strong>Error Message:</strong> ${errors[0].Message}</p>`
    ];
    if (args.length > 0) {
      // special case for ConfirmEnrollmentApiErrorLogExtraData
      if (ApiUtils.isConfirmEnrollmentApiErrorLogExtraData(args[0])) {
        args[0].IntxErrorCode = Number(errors[0].Key);
      }
      const extraHtmlContent = await ErrorLogExtraDataFormatter(args[0]);
      if (extraHtmlContent !== null) {
        extraHtmlContent.forEach((extraContent) => htmlContent.push(extraContent));
      }
    }
    return htmlContent;
  }
  return null;
}
// tslint:enable:no-any
